import React from 'react';
import {Button} from "primereact/button";
import "moment-timezone";
import {AppContext} from "../../HomePage";
import {Badge} from "primereact/badge";
import {CampaignContext} from "../../App";
import {readyToDownloadCount} from "./reportState";

const DownloadReport = (props) => {

    const {t} = React.useContext(AppContext);
    const {toggleDownloadReports, downloadReports} = React.useContext(CampaignContext);

    const readyCount = readyToDownloadCount(downloadReports);

    const badge = readyCount > 0 ? <Badge value={readyCount} severity="danger" />:""

    // The label only appears where the topbar has room for it; below that
    // breakpoint the icon and its tooltip carry the meaning on their own.
    return (
        <React.Fragment>
            <Button className="p-button-text download-report-button" onClick={(e) => {toggleDownloadReports(true);}}
                    tooltip={t('report.my_reports')} tooltipOptions={{position: 'bottom'}} >
                &nbsp;<i className="pi pi-cloud-download p-overlay-badge" >{badge}</i>
                <span className="download-report-label">{t('report.my_reports')}</span>
            </Button>
        </React.Fragment>
    );
};
export default DownloadReport;
